var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"font-weight-bolder font-size-15 mb-0"},[_vm._v(" "+_vm._s(_vm.addressToShow.name)+" ")]),_c('p',{staticClass:"font-weight-small mb-0"},[_vm._v(" "+_vm._s(_vm.addressToShow.address)+" ")]),_c('h6',{staticClass:"font-size-12 secondary"},[_vm._v(" "+_vm._s(_vm.addressToShow.address_detail)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }